import _ from "lodash";

import actions from "./queueActions";
import { sendGetTracksRequest } from "../../../api/spotify.api";

export const handleLoadQueue = (queue) => {
  return { type: actions.LOAD_QUEUE, payload: { queue } };
};

/**
 * The server only sends the queue of tracks with a track URI and the number of votes. We need to fetch track details
 * from Spotify ourselves on the client. The votes are currently handled in the participantReducer, and track details
 * are handled here.
 * @param trackUris
 * @param useCache
 * @returns {function(*, *)}
 */
export const loadTrackDetails = (trackUris, { useCache = true } = {}) => {
  return async (dispatch, getState) => {
    dispatch({ type: actions.START_LOAD_TRACKS_REQUEST });
    let unknownTracks;
    if (useCache) {
      const currentlyKnownTracks = Object.keys(getState().queue.tracks);
      unknownTracks = _.difference(trackUris, currentlyKnownTracks);
    } else {
      unknownTracks = trackUris;
    }
    if (unknownTracks.length > 50) {
      dispatch(
        loadTrackDetails(_.drop(unknownTracks, 50), { useCache: false }),
      );
    }
    if (unknownTracks.length > 0) {
      const tracksOption = await sendGetTracksRequest(
        _.take(unknownTracks, 50),
      );
      if (tracksOption.ok) {
        console.log("tracksOption");
        console.log(tracksOption);
        dispatch({
          type: actions.SUCCESS_LOAD_TRACKS_REQUEST,
          payload: {
            tracks: tracksOption.data.tracks.filter((track) => !_.isNil(track)),
          },
        });
      } else {
        dispatch({
          type: actions.FAIL_LOAD_TRACKS_REQUEST,
          payload: { error: tracksOption.error },
        });
      }
    }
    dispatch({ type: actions.END_LOAD_TRACKS_REQUEST });
  };
};
